<div class="flex w-full">
  <div class="flex w-full h-screen justify-content-center align-items-center">
    <div>
      <div class="overflow-hidden surface-card shadow-2 h-18rem w-full max-w-23rem flex flex-column justify-content-center align-items-center">
        <h1 class="fadeinright animation-duration-1000 animation-iteration-1 p-5">C-BASIC</h1>
        <p class="fadeinleft animation-duration-1000 animation-iteration-1 animation-ease-in p-6">C'est tellement simple de gérer tes achats </p>
      </div>
      <p class="text-xs text-500">version {{version}}</p>

    </div>
   </div>

</div>
